<template>
  <main class="digital-voucher">
    <div class="column">
      <span :class="{ error: invalidItemName }">offer for customer</span>
      <input
        type="text"
        class="item-name-input"
        :class="{ error: invalidItemName }"
        :value="payload.item_name"
        @change="changedForCustomer"
        @blur="blurred('item_name')"
        data-cy="digital-voucher-name-input"
      />
      <span class="error small" v-if="invalidItemName">offer name can't be blank</span>
    </div>


    <span>offer per customer</span>
    <select @change="changedPerCustomer" :value="payload.max_redemptions" class="per-customer-dropdown" data-cy="digital-voucher-max-redemptions-select">
      <option value="-1">unlimited</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="10">10</option>
    </select>

    <div class="column">
      <span :class="{ error: invalidExpiration }">expiration date</span>
      <small>expires at 11:59 PM</small>
      <flat-pickr
        :value="expirationDate"
        :config="flatPickerConfig"
        class="control-expiration flatpickr-input"
        @on-close="changedExpiration"
        data-cy="digital-voucher-expiration-date-input" />
      <span class="error small" v-if="invalidExpiration">must select expiration date</span>
    </div>

    <section v-if="!loadingPreload" style="margin-bottom: 10px">
      <div v-if="!preload" class="attachment-container">
        <a v-file-upload:png,gif,jpeg="changedPreload" style="margin-bottom:3px" data-cy="digital-voucher-preload-image-button">preload image</a>
        <span>sends with your text</span>
      </div>

      <div v-if="preload" class="attachment-container">
        <span>preload image</span>
        <img :src="preload.thumb" alt="preload image" />
        <span class="remove-btn" @click="clickedRemovePreload" data-cy="digital-voucher-preload-image-remove-button">remove</span>
      </div>
    </section>

    <loading-icon v-if="loadingPreload" />

    <section v-if="!loadingVoucher">
      <div v-if="!voucher" class="attachment-container">
        <a v-file-upload:png,gif,jpeg="changedVoucher" style="margin-bottom:3px" data-cy="digital-voucher-voucher-image-button">voucher image</a>
        <span>displays on customer voucher</span>
      </div>

      <div v-if="voucher" class="attachment-container">
        <span>voucher image</span>
        <img :src="voucher.thumb" alt="voucher image" />
        <span class="remove-btn" @click="clickedRemoveVoucher" data-cy="digital-voucher-voucher-image-remove-button">remove</span>
      </div>
    </section>

    <loading-icon v-if="loadingVoucher" />
  </main>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { format } from "date-fns";
import LoadingIcon from "../../shared/LoadingIcon";

export default {
  name: "digital-voucher",
  props: {
    payload: Object,
    preload: Object,
    loadingPreload: Boolean,
    voucher: Object,
    loadingVoucher: Boolean
  },

  data() {
    return {
      flatPickerConfig: {
        altFormat: "D, M j",
        altInput: true,
        altInputClass: 'flatpickr-input control-expiration',
        dateFormat: 'Y-m-d',
        minDate: new Date()
      },
    }
  },

  components: {
    LoadingIcon,
    flatPickr
  },

  methods: {
    blurred(field) {
      this.$store.commit('TOUCHED_FIELD', field);
    },
    changedForCustomer(event) {
      this.$emit('update:payload', { item_name:event.target.value });
    },
    changedPerCustomer(event) {
      this.$emit('update:payload', { max_redemptions:event.target.value });
    },
    changedExpiration(result) {
      this.$emit('update:payload', { expiration_date_local: result.length === 0 ? null : format(result[0], 'Y-dd-MM') });
      this.blurred('expiration_date_local');
    },
    changedPreload(file) {
      this.$emit('update:preload', file);
    },
    clickedRemovePreload() {
      this.$emit('update:preload', null)
    },
    changedVoucher(file) {
      this.$emit('update:voucher', file);
    },
    clickedRemoveVoucher() {
      this.$emit('update:voucher', null);
    }
  },

  computed: {
    invalidItemName() { return this.$store.getters.hasError('item_name'); },
    invalidExpiration() { return this.$store.getters.hasError('expiration_date_local'); },
    expirationDate() {
      if(!this.payload.expiration_date) {
        return null;
      }

      return new Date(this.payload.expiration_date);
    }
  }
}
</script>

<style scoped>
.digital-voucher, .attachment-container, .column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.column {
  margin-bottom: 15px;
}

.attachment-container {
  color: #4a4a4a;
  font-size: 14px;
  font-family: AileronThin;
}

.digital-voucher sub {
  font-family: 'AileronThin';
  font-size: 14px;
  color: #a4a4a4;
  margin-bottom:25px;
}

.digital-voucher a {
  font-family: "AileronLight";
  margin-bottom: 5px;
}

.per-customer-dropdown {
  max-width: 100px;
}

img {
  height: 75px;
  border: 1px solid #128ff9;
}

.remove-btn {
  cursor: pointer;
}

input, .flatpickr-input, .control-expiration {
  width: 100%;
  margin-bottom: 0px;
}

.error {
  border-color: #f91253;
}

.error.small {
  color: #f91253;
  font-size: .75rem;
  font-family: AileronThin;
}
</style>
